module.exports = __webpack_public_path__ + "img/ic_notify_yellow.4eeb9224.svg";